import { COLORS } from '~/themes/common'

const style = () => ({
  fileContainer: {
    position: 'relative',
    cursor: 'pointer',
    width: '100%',
    paddingTop: '100%',
    border: '1px solid #B4BFD9',
    borderRadius: 3,
    boxSizing: 'content-box',
    '&.selected': {
      border: `1px solid ${COLORS.palette.primaryBlue}`,
    },
  },
  imageContainer: {
    WebkitUserSelect: 'none',
    KhtmlUserSelect: 'none',
    MozUserSelect: 'none',
    OUserSelect: 'none',
    userSelect: 'none',
    position: 'absolute',
    borderRadius: 3,
    top: 0,
    left: 0,
    bottom: 0,
    right: 0,
  },
  image: {
    width: '100%',
    height: '100%',
    objectFit: 'contain',
  },
  videoContainer: {
    position: 'absolute',
    borderRadius: 3,
    top: 0,
    left: 0,
    bottom: 0,
    right: 0,
    '&.video': {
      height: '100%',
      width: '177.78%',
      transform: 'translateX(-50%)',
      left: '50%',
      right: 'auto',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    },
  },
  selectedButtonContainer: {
    position: 'absolute',
    bottom: -5,
    right: -5,
  },
  selectedButton: {
    margin: 0,
  },
  checkedIcon: {
    width: 12,
    height: 12,
  },
  uncheckedIcon: {
    width: 12,
    height: 12,
  },
  listFileContainer: {
    overflowY: 'auto',
  },
  video: {
    width: '100% !important',
    height: '100% !important',
    position: 'absolute',
  },
  videoImage: {
    width: '50%',
    height: '50%',
    position: 'absolute',
    zIndex: 2,
    marginTop: '25%',
    marginLeft: '25%',
  },
  containerLoadMore: {
    textAlign: 'center',
    width: '100%',
    padding: 5,
    fontSize: 12,
  },
  bgFile: {
    position: 'absolute',
    width: '100%',
    height: '100%',
    top: '0',
    left: '0',
    background: COLORS.palette.primaryBlue,
    zIndex: 1,
    opacity: '0.4',
    display: 'none',
  },
  gridContainer: {
    width: '100%',
    '@media screen and (max-width: 1024px)': {
      '& > div:last-of-type': {
        paddingBottom: 50,
      },
    },
  },
})

export default style
